export default "__VITE_ASSET__h7_lEM4F__"